module.exports = __webpack_public_path__ + "static/img/HT-S350.77791749.jpg";